module.exports = __webpack_public_path__ + "static/media/Fig-2-4.91114669.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-2-4.svg
// module id = 648
// module chunks = 0